import React from 'react';
import Lottie from 'lottie-react';

const CardWapp = ({ title, value,suffix, animationData, onClick }) => {
    const phoneNumber = '+40760873168'; // Without + or spaces
    const message = 'Hello%20there!';
    const handleWhatsAppClick = () => {
        // This is the direct link to open WhatsApp (or WhatsApp Web)
        const url = `https://wa.me/${phoneNumber}?text=${message}`;
        window.open(url, '_blank', 'noopener,noreferrer');
      };
  
    return (
      <div 
        onClick={handleWhatsAppClick}
        className="w-full my-2 bg-[#34495e] border-2 border-[#2ecc71] rounded-[10px] flex items-center justify-between p-4 cursor-pointer"
        style={{ minHeight: '50px', maxHeight:'60px' }} // Slightly taller than 50px to fit text & animation
      >
  
  <div className="flex-shrink-0">
          {animationData && (
            <Lottie 
              animationData={animationData} 
              style={{ width: 40, height: 40 }} 
            />
          )}
        </div>
        <div className="flex items-center flex-col text-white mr-4">
          <span className="text-sm font-extrabold text-[#e67e22] 00font-medium">{title}</span>
          {value && 
          <span className="text-sm font-semibold">
            {value}
        </span>}
        </div>
      </div>
    );
  };
  
  export default CardWapp;